export default __webpack_public_path__ + "static/media/(6).abc40ac3.jpg";